import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import SDSelect from '@/shared/components/SDComponentsNewDesign/SDSelect/SDSelect'

import useAddEditModal from './useAddEditModal'

interface AddEditModalProps {
  setIsOpen: (open: boolean) => void
  close: () => void
}

const AddEditModal = ({ setIsOpen, close }: AddEditModalProps) => {
  const {
    t,
    formErrors,
    selectedWebsalesUser,
    isEdit,
    originOptions,
    selectedOrigin,
    selectOrigin,
    updateSelectedWebsalesUser,
    submitHandler,
  } = useAddEditModal({ setIsOpen })

  return (
    <form onSubmit={submitHandler}>
      <SDFormControl
        label={t('websalesUsersManagement:modal.username')}
        error={formErrors.username ? formErrors.username[0] : ''}
      >
        {/* @ts-expect-error SDInput is a JS component */}
        <SDInput
          id='websales-user-username'
          currentValue={selectedWebsalesUser.username}
          outerOnchange={(value: string | null) => updateSelectedWebsalesUser({ username: value ?? '' })}
        />
      </SDFormControl>
      <SDFormControl
        hidden={isEdit}
        label={t('websalesUsersManagement:modal.password')}
        error={formErrors.password ? formErrors.password[0] : ''}
        caption={t('websalesUsersManagement:modal.password_caption')}
      >
        {/* @ts-expect-error SDInput is a JS component */}
        <SDInput
          id='websales-user-password'
          type='password'
          autoComplete='new-password'
          currentValue={selectedWebsalesUser.password}
          outerOnchange={(value: string | null) => updateSelectedWebsalesUser({ password: value ?? '' })}
        />
      </SDFormControl>
      <SDFormControl error={formErrors.origin ? formErrors.origin[0] : ''}>
        {/* @ts-expect-error SDSelect is a JS component */}
        <SDSelect
          id='websales-user-origin'
          label={t('websalesUsersManagement:modal.origin')}
          optionsList={originOptions}
          selectedValue={selectedOrigin}
          hasError={!!formErrors.origin}
          onChangeHandler={selectOrigin}
        />
      </SDFormControl>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton type='submit' overrides={{ BaseButton: { style: () => ({ marginRight: '.5rem' }) } }}>
        {isEdit ? t('common:edit') : t('common:create')}
      </SDButton>
      {/* @ts-expect-error SDButton is a JS component */}
      <SDButton type='button' kind='secondary' onClick={close}>
        {t('common:cancel')}
      </SDButton>
    </form>
  )
}

export default AddEditModal
